
import Vue from 'vue'
import * as Api from '@/api/SchoolSettingsApi'
import {
   Checkbox,
   Textbox,
   TextArea,
   MultiSelect,
   DropDownSelect,
   DatePicker,
} from '@/components/formGroups'
import { SchoolStudentDto } from '@ViewModels/SchoolStudentDto'

export default Vue.extend({
   name: 'StudentDetailsForm',
   props: {
      schoolId: String,
      editingItem: Object as () => SchoolStudentDto,
      loading: Boolean,
   },
   data() {
      return {
         classroomOptions: [] as NameValuePair[],
         ethnicityOptions: [] as NameValuePair[],
         targetTypeOptions: [] as NameValuePair[],
         genderOptions: [
            { name: 'Female', value: 0 },
            { name: 'Male', value: 1 },
         ] as NameValuePair[],
      }
   },
   computed: {
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },
      userIsSchoolAdmin(): boolean {
         return this.$store.getters.userIsSchoolAdmin
      },
      selectedSchoolYear(): number {
         return this.$store.getters.selectedSchoolYear
      },
   },
   mounted() {
      this.loadClassroomOptions()
      this.loadTargetTypeOptions()
      this.loadEthnicityOptions()
   },
   methods: {
      async loadClassroomOptions() {
         this.classroomOptions = await Api.getClassroomOptionsForSchoolYear(
            this.schoolId,
            this.selectedSchoolYear
         )
      },
      async loadTargetTypeOptions() {
         this.targetTypeOptions = await Api.getTargetTypeOptions(this.schoolId)
      },
      async loadEthnicityOptions() {
         this.ethnicityOptions = await Api.getEthnicityOptions(this.schoolId)
      },
   },
   components: {
      Checkbox,
      Textbox,
      TextArea,
      MultiSelect,
      DropDownSelect,
      DatePicker,
   },
})
